export default __webpack_public_path__ + "assets/TKO-ship.e980d3e8.png";